import React from 'react';
import VBox from '../../components/layout/VBox';
import Markdown from '../chat/Markdown';
import styles from './page.module.css';

const PoliticaRetencaoPage = () => {
    return (
        <VBox style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
            <Markdown className={styles.container} value={`
# POLÍTICA DE RETENÇÃO DE DADOS – TERACHAT

**Última atualização:** 09/09/2026

Esta Política de Retenção descreve os prazos e critérios de conservação e descarte dos dados pessoais tratados pela **Terachat** no contexto da prestação de seus serviços, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).

---

## 1. Papéis na LGPD

- **Cliente:** Controlador dos dados pessoais de seus usuários e clientes finais, responsável por definir as finalidades do tratamento;
- **Terachat:** Operadora, tratando dados conforme instruções do Cliente.

---

## 2. Critérios Gerais de Retenção

Os dados pessoais são mantidos apenas pelo tempo necessário para:
- Execução dos serviços contratados;
- Cumprimento de obrigações legais e regulatórias;
- Exercício regular de direitos em processos judiciais, administrativos ou arbitrais;
- Finalidades de segurança e prevenção a fraudes.

Após o fim da necessidade, os dados são **excluídos ou anonimizados**, de forma que não permitam a identificação do titular.

---

## 3. Prazos por Categoria de Dados

| Categoria de dados | Registros abrangidos | Prazo de retenção |
| --- | --- | --- |
| Dados cadastrais do Cliente e usuários | Cadastro da conta, usuários e configurações | Durante a vigência do contrato |
| Conversas de atendimento | Chat e mensagens, marcadores, pontuações e supervisões de IA | 180 dias |
| Atividades e tickets | Atividades, tickets, anexos e interações | 180 dias |
| Campanhas de mensagens | Mensagens de campanha e seus eventos | 90 dias |
| Fila de atendimento | Registros de distribuição de atendimentos | 180 dias |
| Estado de chatbots | Estados de conversas com chatbot | 180 dias |
| Requisições de IA | Requisições enviadas a serviços de IA | 180 dias |
| Respostas de mini-formulários | Respostas e arquivos associados | 180 dias |
| Sessões de acesso | Histórico de sessões e presença de usuários em chat | 3 a 15 dias |
| Notificações pendentes | Notificações ainda não processadas | 15 dias |
| Retornos agendados | Registros já processados (não pendentes) | 30 dias |
| Trilha de auditoria | Registros de auditoria do sistema | 12 meses |
| Arquivos de exportação de conversas | Jobs e arquivos de exportação de chat | 7 dias |
| Backups | Arquivos e registros de backup | 30 dias |
| Dados mantidos por obrigação legal | Fiscais, tributários e contábeis | Prazo previsto na legislação aplicável |

---

## 4. Encerramento da Relação Contratual

Após o encerramento da relação contratual com o Cliente:
- Os dados poderão ser **excluídos ou anonimizados**, salvo obrigação legal em contrário;
- O Cliente pode solicitar a exclusão dos dados por meio dos canais de contato da Terachat.

---

## 5. Backups

Dados podem subsistir temporariamente em rotinas de backup, por prazo limitado, sendo eliminados à medida que os ciclos de backup forem renovados. Dados em backup não são utilizados para nenhuma finalidade operacional.

---

## 6. Descarte Seguro

A exclusão de dados é realizada por meio de práticas que asseguram que as informações não possam ser recuperadas, incluindo a eliminação de cópias acessíveis e a sobrescrita segura quando aplicável.

---

## 7. Direitos dos Titulares

O exercício dos direitos dos titulares de dados (acesso, correção, exclusão, portabilidade, etc.) deve ser solicitado ao Cliente, enquanto controlador. A Terachat prestará apoio técnico ao Cliente, quando aplicável.

---

## 8. Alterações nesta Política

Esta Política pode ser atualizada periodicamente. A versão vigente estará sempre disponível na plataforma ou site da Terachat.

---

## 9. Contato

Em caso de dúvidas sobre esta Política, entre em contato pelo e-mail:

**contato@terachat.com.br**
`} />
        </VBox>
    );
};

export default PoliticaRetencaoPage;